import { APIResponse } from '../api/api';

export type ApOverviewResponse = {
    online: number;
    max_aps: number;
};
export type TagOverviewResponse = {
    online_tags: number;
    max_tags: number;
};
export type JobOverviewResponse = {
    success_jobs: number;
    max_jobs: number;
};
export type OverViewInfo = {
    loading: boolean;
    hasData: boolean;
    online: number;
    max: number;
    ratioNum: string[];
};
export type DashboardCards = {
    [k in OVERVIEW_TYPE]: OverViewInfo;
};
export interface OverviewAction {
    target: OVERVIEW_TYPE;
    loading?: boolean;
    hasData?: boolean;
    info?: ApOverviewResponse | TagOverviewResponse | JobOverviewResponse;
}
export type DashboardPageAction = { type: 'SET_OVERVIEW_STATE'; payload: OverviewAction };

export enum OVERVIEW_TYPE {
    AP = 'AP',
    TAG = 'TAG',
    JOB = 'JOB',
}

export type OverviewMap = {
    [K in OVERVIEW_TYPE]: (cid: number) => APIResponse<ApOverviewResponse | TagOverviewResponse | JobOverviewResponse>;
};
